import { useEffect, useMemo, useState } from "react";

const LS_ROLE_KEY = "export_role";
const LS_COMPANY_KEY = "export_company";
const LS_NAME_KEY = "export_applicant_name";

const safeGet = (key: string) => {
  try {
    return localStorage.getItem(key) || "";
  } catch {
    return "";
  }
};

const safeSet = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch {
    // ignore
  }
};

export const useExportNamingPrefs = () => {
  const [role, setRole] = useState("");
  const [company, setCompany] = useState("");
  const [applicantName, setApplicantName] = useState("");

  useEffect(() => {
    setRole(safeGet(LS_ROLE_KEY));
    setCompany(safeGet(LS_COMPANY_KEY));
    setApplicantName(safeGet(LS_NAME_KEY));
  }, []);

  useEffect(() => safeSet(LS_ROLE_KEY, role), [role]);
  useEffect(() => safeSet(LS_COMPANY_KEY, company), [company]);
  useEffect(() => safeSet(LS_NAME_KEY, applicantName), [applicantName]);

  const applicantFirstName = useMemo(() => {
    const parts = applicantName.trim().split(/\s+/).filter(Boolean);
    return parts[0] || "";
  }, [applicantName]);

  return {
    role,
    setRole,
    company,
    setCompany,
    applicantName,
    setApplicantName,
    applicantFirstName,
  };
};
